import { render, staticRenderFns } from "./SettingsRental.vue?vue&type=template&id=fe37f966&scoped=true&"
import script from "./SettingsRental.vue?vue&type=script&lang=ts&"
export * from "./SettingsRental.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe37f966",
  null
  
)

export default component.exports